import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "animate-fade-in" }
const _hoisted_2 = { class: "flex justify-between items-center mb-12" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "space-y-1.5" }
const _hoisted_6 = { class: "font-display text-[24px] sm:text-[28px] font-bold text-stone-900 dark:text-stone-50 tracking-tight" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "prose-minimal text-stone-700 dark:text-stone-200" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_11 = { class: "overflow-hidden" }

import ProjectImageGallery from "@/components/common/ProjectImageGallery.vue";
import CustomText from "@/components/common/CustomText.vue";
import DarkModeToggle from "@/components/common/DarkModeToggle.vue";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { usePortfolioStore } from "@/store/portfolioStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const portfolioStore = usePortfolioStore();
const { portfolio } = storeToRefs(portfolioStore);

const currentProject = computed(() => {
  return portfolio.value?.projects.find(
    (project) => project.slug === route.params.slug
  );
});

const techPills = computed(() => {
  return (
    currentProject.value?.technologies?.map((t) => t.name).filter(Boolean) || []
  );
});

const goBack = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: goBack,
        class: "inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-800 dark:hover:text-stone-200 transition-colors group"
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          class: "w-4 h-4 transition-transform group-hover:-translate-x-1",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          })
        ], -1),
        _createTextVNode(" Back ", -1)
      ]))]),
      _createVNode(DarkModeToggle)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("header", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-stone-500 dark:text-stone-500" }, [
            _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-brand-500" }),
            _createTextVNode(" Project Overview ")
          ], -1)),
          _createElementVNode("h1", _hoisted_6, _toDisplayString(currentProject.value?.name), 1),
          (currentProject.value?.projectUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: currentProject.value?.projectUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "inline-flex items-center gap-2 text-sm font-semibold text-stone-800 dark:text-stone-100 hover:text-stone-600 dark:hover:text-stone-200 transition-colors"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "View Live Project", -1),
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5",
                    d: "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  })
                ], -1)
              ]))], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(CustomText, {
              value: currentProject.value?.description
            }, null, 8, ["value"])
          ]),
          (techPills.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(techPills.value, (tech) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tech,
                    class: "inline-flex items-center px-3 py-1 rounded-full bg-stone-100 dark:bg-stone-800 text-stone-700 dark:text-stone-300 text-[12px] font-medium"
                  }, _toDisplayString(tech), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ProjectImageGallery, {
          images: currentProject.value?.images
        }, null, 8, ["images"])
      ])
    ])
  ]))
}
}

})